import { connect } from 'react-redux'
import * as actions from '../../../actions'
import UserMenu from '../components/UserMenu'

const mapStateToProps = (state) => {
  const { user } = state.authentication
  const { settings } = state.settings
  const { anchorEl } = state.userMenu
  const { language } = state.user
  return ({
    user,
    settings,
    anchorEl,
    open: Boolean(anchorEl),
    language,
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
    handleClickMenu: (event) => {
      dispatch(actions.userMenu.open(event.currentTarget))
    },
    handleClose: () => {
      dispatch(actions.userMenu.close())                
    },
    handleLogOut: () => {
      dispatch(actions.userMenu.close())
    },
    handleTweetListDialog: (event) => {
      dispatch(actions.tweetListDialog.open())
      dispatch(actions.userMenu.close())
    },
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(UserMenu)




// WEBPACK FOOTER //
// ./src/Parts/MenuAppBar/containers/UserMenu.js